export const getAnnualRate = (userData) => {
  if (!userData?.ratePerClient || !userData?.clients || !userData?.sessionLength) {
    return null;
  }
  return (
    userData.ratePerClient *
    userData.clients *
    userData.sessionLength *
    52
  ).toLocaleString();
};

export const getWeeklyRate = (userData) => {
  if (!userData?.ratePerClient || !userData?.clients || !userData?.sessionLength) {
    return null;
  }
  return (
    userData.ratePerClient *
    userData.clients *
    userData.sessionLength
  ).toLocaleString();
};

export const hasCalculatorData = (userData) =>
  userData?.showTotalIncome &&
  userData?.clients &&
  userData?.ratePerClient &&
  userData?.sessionLength &&
  userData?.startDate;
